var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flip-device"},[_c('h2',{staticClass:"flip-device__title"},[_vm._v("Переверните устройство"),_c('br'),_vm._v("в вертикальное положение")]),_c('div',{staticClass:"flip-device__icon"},[_c('img',{attrs:{"src":"/frontend/assets/i/flip-phone.svg"}})])])
}]

export { render, staticRenderFns }